import { useToggle } from '@uidotdev/usehooks';
import { User, Shield } from 'lucide-react';

import ChangePassword from './components/ChangePassword';
import { Button } from '../../components/atoms/new-button';
import CustomModal from '../../components/molecules/Modals/CustomModal';
import PageWrapper from '../../components/molecules/PageWrappers/PageWrapper';
import { useUserContext } from '../../Contexts/User';
import { Label } from '@/components/atoms/label';

const Settings = () => {
  const { user } = useUserContext();
  const [isChangePasswordModalOpen, toggleChangePasswordModal] = useToggle(false);

  if (!user) return null;

  return (
    <PageWrapper className="bg-gray-50">
      <div className="flex w-full flex-col items-start justify-start px-4 md:px-6 lg:px-8">
        <div className="mb-8 flex w-full flex-col gap-6">
          {/* Header Section */}
          <div className="w-full rounded-xl bg-white p-6 shadow-sm">
            <div className="flex flex-col">
              <h1 className="text-xl font-semibold text-gray-800">User Settings</h1>
              <p className="text-sm text-gray-600">Manage your account preferences and security settings.</p>
            </div>
          </div>

          {/* Profile Information Section */}
          <div className="w-full rounded-xl bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-6">
              <div className="flex items-center gap-3">
                <div className="rounded-full bg-blue-50 p-2">
                  <User className="text-brandSecondary h-5 w-5" />
                </div>
                <h2 className="text-lg font-medium text-gray-700">Profile Information</h2>
              </div>

              <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                <div className="flex flex-col gap-2">
                  <Label className="text-sm font-semibold text-gray-700">Email Address</Label>
                  <p className="text-sm text-gray-600">{user.email}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Security Settings Section */}
          <div className="w-full rounded-xl bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-6">
              <div className="flex items-center gap-3">
                <div className="rounded-full bg-green-50 p-2">
                  <Shield className="h-5 w-5 text-green-600" />
                </div>
                <h2 className="text-lg font-medium text-gray-700">Security Settings</h2>
              </div>

              <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                <div className="flex items-center justify-between">
                  <div className="flex flex-col gap-2">
                    <Label className="text-sm font-semibold text-gray-700">Password</Label>
                    <p className="text-sm text-gray-600">Update your account password</p>
                  </div>
                  <Button variant="primary" onClick={() => toggleChangePasswordModal()} className="text-sm">
                    Change Password
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        isOpen={isChangePasswordModalOpen}
        handleClose={toggleChangePasswordModal}
        content={<ChangePassword onSuccess={toggleChangePasswordModal} />}
      />
    </PageWrapper>
  );
};

export default Settings;
